import type React from "react"
import { NavLink } from "react-router-dom"
import {
  RiMapLine,
  RiMapFill,
  RiBookmarkLine,
  RiBookmarkFill,
  RiCommunityLine,
  RiCommunityFill,
  RiUserLine,
  RiUserFill,
} from "react-icons/ri"
import { useAppSelector, useAppDispatch } from "@/app/hooks"
import {
  selectIsAuthenticated,
  setLoginSheetOpen,
} from "@/features/auth/authSlice"
import "@/styles/BottomGNB.css"

export const BottomGNB: React.FC = () => {
  const dispatch = useAppDispatch()
  const isAuthenticated = useAppSelector(selectIsAuthenticated)

  const handleProtectedClick = (e: React.MouseEvent, _to: string) => {
    if (!isAuthenticated) {
      e.preventDefault()
      dispatch(setLoginSheetOpen(true))
    }
  }

  const navItems = [
    {
      to: "/",
      label: "차박지도",
      Icon: RiMapLine,
      ActiveIcon: RiMapFill,
      isProtected: false,
    },
    {
      to: "/bookmarks",
      label: "북마크",
      Icon: RiBookmarkLine,
      ActiveIcon: RiBookmarkFill,
      isProtected: true,
    },
    {
      to: "/community",
      label: "커뮤니티",
      Icon: RiCommunityLine,
      ActiveIcon: RiCommunityFill,
      isProtected: false,
    },
    {
      to: "/profile",
      label: "마이페이지",
      Icon: RiUserLine,
      ActiveIcon: RiUserFill,
      isProtected: true,
    },
  ]

  return (
    <nav className="bottom-gnb">
      {navItems.map(({ to, label, Icon, ActiveIcon, isProtected }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => `gnb-item ${isActive ? "active" : ""}`}
          onClick={e => isProtected && handleProtectedClick(e, to)}
          end={to === "/"} // "차박지도"는 정확히 "/"일 때만 active
        >
          {({ isActive }) => (
            <>
              <div className="gnb-icon">
                {isActive ? <ActiveIcon /> : <Icon />}
              </div>
              <div className="gnb-label">{label}</div>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
